package com.sweetlime.bingeamigo.model.types

enum class ActivityType(val value: Int) {
    ADD_WATCHLIST(1),
    MARK_WATCHED(2),
    RATE_MOVIE(3),
    REVIEW_MOVIE(4),
    FAVORITE_MOVIE(5),
    FOLLOW_USER(6),
    LIKE_REVIEW(7),
    COMMENT_REVIEW(8),
    CREATE_LIST(9),
    FOLLOW_LIST(10),
    SHARE_MOVIE(11),
    REWATCH_MOVIE(12),
    ADD_SHOW_TRACKING(13),
    FAVORITE_SHOW(14),
    COMPLETE_SHOW(15),
    EPISODE_WATCHED(16),
    RATE_SHOW(17),
    RATE_EPISODE(18);

    companion object {
        fun fromValue(value: Int): ActivityType? {
            return entries.firstOrNull { it.value == value }
        }
    }
}